module.exports = __webpack_public_path__ + "img/step2.cc0fc06a.svg";